/* @flow strict */

import * as React from 'react';
import { NavLink } from 'react-router-dom';

import './styles.scss';

const NotFound = ({}: PropsType): React.Element<typeof React.Fragment> => {
  const [showSorry, handleShowShowSorry] = React.useState(false);
  const showSorryTimeout = setTimeout(() => {
    handleShowShowSorry(true);
  }, 1500);

  if (showSorry) {
    clearTimeout(showSorryTimeout);

    return (
      <div className='Service-msg'>
        <h1>Sorry, this page isn't available</h1>
        <h4>
          The link you followed may be broken, or the page may have been removed. &nbsp;
          <NavLink to='/events'>Go back to Sparxo.</NavLink>
        </h4>
      </div>
    );
  }

  return null;
};

export default NotFound;
